/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_EventsInputs */



/**
* | output |
* | --- |
* | "Reference Events" |
*
* @param {Reference_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reference_events = /** @type {((inputs?: Reference_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements de référence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Referenzereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi di riferimento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Справочные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos de referencia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("参考事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("参照イベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संदर्भ घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos de referência")
	return /** @type {LocalizedString} */ ("Reference Events")
});